import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueMeta from 'vue-meta'
import VueCookies from 'vue-cookies'
Vue.use(VueMeta, { refreshOnceOnNavigation: true })
Vue.use(VueCookies)

// bootstrap section
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
Vue.use(BootstrapVue)

// custom components section
import header from './components/header.vue'
import footer from './components/footer.vue'
import basement from './components/basement.vue'
import company from './components/company.vue'
Vue.component('eco-header', header)
Vue.component('eco-footer', footer)
Vue.component('eco-basement', basement)
Vue.component('eco-company-view', company)

Vue.config.productionTip = false

window.$apiurl = 'https://api.roecocity.ru/oldcwapi'
window.$showError = (err) => {
	window.$error = err
	window.$vue.$router.push('error')
}

import store from './store.js'
window.$vue = new Vue({
	store: store,
	router: router,
	render: h => h(App)
}).$mount('#app')
